<template>
  <div class="reports-page">
    <app-page-header title="Relatórios"></app-page-header>
    <reports-table ref="reportsTable"></reports-table>
  </div>
</template>

<script>
import ReportsTable from '@/components/Tables/ReportsTable.vue';

export default {
  name: 'reports-page',
  components: {
    ReportsTable,
  },
};
</script>

<style lang="scss" scoped></style>
